import React from 'react'

export default function Discog() {
	return (
		<div>
			
		</div>
	)
}
